import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isToday from "dayjs/plugin/isToday";
dayjs.extend(customParseFormat);
dayjs.extend(isToday);

const getTimeHr = (hour) => {
  return dayjs(hour, "HH:mm:ss").format("HH:mm");
};

const getTime = (date) => {
  return dayjs(date);
};

const getTimeDifference = (hour1, format1, hour2, format2) => {
  const firstDate = dayjs(hour1, format1);
  const secondDate = dayjs(hour2, format2);

  const minutesDifference = secondDate.diff(firstDate, "minute");
  const hours = Math.floor(minutesDifference / 60);
  let minutes = minutesDifference % 60;

  if (minutesDifference < 0) {
    minutes = minutes * -1;
    const zero = minutes < 10 ? "0" : "";
    return `${hours}:${zero}${minutes}`;
  }

  const zero = minutes < 10 ? "0" : "";
  return `${hours}:${zero}${minutes}`;
};

const getNumberHours = (hourParam) => {
  const hour = Number(hourParam.substring(0, 2));
  const minutes = Math.round((Number(hourParam.slice(-2)) / 60) * 100) / 100;
  return hour + minutes;
};

export { getTime, getTimeDifference, getTimeHr, getNumberHours };
